import { useCallback, useRef, useState } from "react";

export default function useAcaoLocalFaturamento() {
  const [emAndamento, setEmAndamento] = useState(false);
  const emAndamentoRef = useRef(false);

  const executar = useCallback(async (acao) => {
    if (emAndamentoRef.current) {
      return undefined;
    }

    emAndamentoRef.current = true;
    setEmAndamento(true);

    try {
      return await acao();
    } finally {
      emAndamentoRef.current = false;
      setEmAndamento(false);
    }
  }, []);

  return { emAndamento, executar };
}
